import { Component, EventEmitter, Input, OnInit, Output, Type } from '@angular/core';
import { NgStyle, NgClass } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIconButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'uw-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    imports: [NgStyle, NgClass, MatProgressSpinner, MatIconButton, TranslateModule]
})
export class UwButtonComponent implements OnInit {
  @Input() isIconButton: boolean = false;
  @Input() disabled: boolean = false;
  @Input() routerLink!: string;
  @Input() btnLabel: string = '';
  @Input() customClass: string = '';
  @Input() inId: string = '';
  @Input() type: string = 'submit';
  @Input() buttonIcon: string = '';
  @Input() customStyle: { [klass: string]: any; } | null = null;
  @Input() btnTypeDefault: boolean = false;
  @Input() btnTypePrimary: boolean = false;
  @Input() btnTypeDanger: boolean = false;
  @Input() btnStretch: boolean = false;
  @Input() buttonSubmit = false;
  @Input() isMediumSize  = false;
  @Input()
  set loading(loading: boolean) {
    this._loading = loading || false;
  }
  get loading(): boolean {
    return this._loading;
  }
  @Output() buttonClick!: EventEmitter<any>;
  active = false;
  buttonType!: string;
  private _loading: boolean = false;

  constructor() {
    this.buttonClick = new EventEmitter<any>();
    this.buttonType = this.buttonSubmit ? `submit` : `button`;
  }

  ngOnInit(): void {
  }

  onClick(): any {
    if (this.disabled || this.loading) {
      return;
    } else {
      this.buttonClick.emit(this.btnLabel + ` clicked`);
    }
  }
}
